import CSS from './sticky-sidebar.module.css'

export const StickySidebar = ({ children, backgroundColor }) => {
    return (
        <section className={CSS.layout} style={{ backgroundColor }}>
            { children }
        </section>
    )
}


export const StickySidebarSection = ({ children, decal }) => {
    return (
        <section className={`${CSS.wrapper} ${decal}`}>
            <div className={`${CSS.section} maxw-60`}>
                { children }
            </div>
        </section>
    )
}